import { Avatar } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { User } from 'lib-shared-types-api';

import { getUserDisplayName } from 'utils/user';

import styles from './messageTyping.module.scss';

interface Props {
  /** The author. */
  author: User;
  /** Extra classnames. */
  className?: string;
}

/** Represents a message with an avatar and a four dot typing indicator. */
export function MessageTyping({ className, author }: Props): JSX.Element {
  const rootClass = classnames(
    {
      [styles.root]: true,
    },
    className,
  );

  return (
    <div className={rootClass}>
      <div className={styles.avatarWrap}>
        <Avatar user={author} />
      </div>
      <div>
        <p className={styles.name}>{getUserDisplayName(author)}</p>
        <div className={styles.indicator}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
        </div>
      </div>
    </div>
  );
}
